export const NAVIGATION_CONSTANTS  = Object.freeze({
  // TODO Improve routes naming
  ROOT: '/adm',
  SETTINGS_ROUTE: '/adm/Settings/',
  // identifications
  IDENTIFICATION_ROUTE: '/adm/identifications',
  IDENTIFICATION_CLIENTS_ROUTE: '/adm/identifications/clients',
  IDENTIFICATION_CLIENTS_DETAIL_ROUTE: '/adm/identifications/clients/:clientId?',
  IDENTIFICATION_USERS_ROUTE: '/adm/identifications/users/:showAll?',
  IDENTIFICATION_USERS_DETAIL_ROUTE: '/adm/identifications/user/:subjectId?',
  IDENTIFICATION_APIS_ROUTE: '/adm/identifications/apis',

  // customer (company) creation
  COMPANY_CREATION_ROUTE: '/adm/company-create',
  COMPANY_CREATION_ROUTE_ACCOUNT_REGISTRATION: '/adm/company-create/account-registration',
  COMPANY_CREATION_ROUTE_BILLING_ADDRESS_ROUTE: '/adm/company-create/billing-address',
  COMPANY_CREATION_ROUTE_USER_REGISTRATION: '/adm/company-create/user-registration',
  COMPANY_CREATION_ROUTE_SUMMARY: '/adm/company-create/summary',

  // customer (company) administration
  COMPANY_ADMINISTRATION_ROUTE: '/adm/company-administration',
  COMPANY_ADMINISTRATION_ACCOUNT_ROUTE: '/adm/company-administration/account',
  COMPANY_ADMINISTRATION_USER_ROUTE: '/adm/company-administration/user',
  COMPANY_ADMINISTRATION_APPLICATION_ACCESS_ROUTE: '/adm/company-administration/application_access',
  COMPANY_ADMINISTRATION_API_KEYS_ROUTE: '/adm/company-administration/api_keys',

  COMPANY_ADMINISTRATION_AUDIT_LOG_ROUTE: '/adm/company-administration/audit-log',

  // Oliasoft internal customers administration
  CUSTOMER_ADMINISTRATION_ROUTE: '/adm/company',
  CUSTOMER_ADMINISTRATION_ACCOUNT_ROUTE: '/adm/company/:customerId?/account',
  CUSTOMER_ADMINISTRATION_USER_ROUTE: '/adm/company/:customerId?/user',
  CUSTOMER_ADMINISTRATION_LICENSE_ROUTE: '/adm/company/:customerId?/license',
  CUSTOMER_ADMINISTRATION_APPLICATION_ACCESS_ROUTE: '/adm/company/:customerId?/application_access',
  CUSTOMER_ADMINISTRATION_FEATURE_FLAG_ACCESS_ROUTE: '/adm/company/:customerId?/feature_flag_access',
  CUSTOMER_ADMINISTRATION_API_KEYS_ROUTE: '/adm/company/:customerId?/api_keys',
  CUSTOMER_ADMINISTRATION_AUDIT_LOG_ROUTE: '/adm/company/:customerId?/audit-log',

  // General License administration page
  LICENSE_ADMINISTRATION_ROUTE: '/adm/license_administration',

  // Roles administration
  ROLE_ADMINISTRATION_ROUTE: '/adm/role_administration',

  // Subject administration
  SUBJECT_ADMINISTRATION_ROUTE: '/adm/subject_administration',
  FEATURE_FLAGS_ADMINISTRATION_ROUTE: '/adm/feature_flags',

  STATISTICS_ROUTE: '/adm/statistics',

  PAYLOAD_COMPARISON_ROUTE: '/adm/payload_comparison',

  EXTERNAL_USERS_REQUESTS_ROUTE: '/adm/external_users_requests',

  SURVEYS_ROUTE: '/adm/surveys',
  SURVEY_ROUTE: '/adm/survey',
  RELEASE_NOTES_ROUTE: '/adm/release-notes',
  RELEASE_NOTES_ADMINISTRATION_ROUTE: '/adm/release-notes'
});

export const NotificationTypes = Object.freeze({
  DEFAULT: 'Info',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  ERROR: 'Error',
});

export const dateOnlyFormat = 'YYYY-MM-DD';

export const PREDEFINED_ROLES = Object.freeze({
  ACCOUNT_OWNER: 'Account Owner'
});